module.exports = __webpack_public_path__ + "static/fonts/font.2d6034f.woff2";